/* eslint-disable no-restricted-syntax */
import {useState} from 'react';
import {Button, TextField, Dialog, DialogContent, DialogActions, DialogContentText, Divider} from '@mui/material';
import DialogTitleWithClose from 'components/Generic/DialogTitle';
import {useTranslation} from 'react-i18next';

export function AddFolderDialog({
  open,
  handleClose,
  handleCreate,
  ...props
}: {
  open: boolean;
  handleClose: () => void;
  handleCreate: (name) => void;
}) {
  const {t} = useTranslation('common');
  const [name, setName] = useState<string>();

  return (
    <Dialog open={open} onClose={handleClose} aria-labelledby="add-folder-dialog" maxWidth="sm" {...props}>
      <DialogTitleWithClose onClose={handleClose}>{t('addFolder')}</DialogTitleWithClose>
      <Divider />
      <DialogContent>
        <DialogContentText pb={2}>{t('addFolderDialogText')}</DialogContentText>
        <TextField
          variant="outlined"
          autoFocus
          margin="dense"
          id="name"
          label={t('folderName')}
          type="text"
          fullWidth
          onChange={(event) => {
            setName(event.target.value);
          }}
          error={name === ''}
          helperText={name === '' ? t('emptyFolderName') : ''}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary" size="small">
          {t('cancel')}
        </Button>
        <Button
          onClick={() => {
            handleCreate(name);
            handleClose();
          }}
          type="submit"
          color="primary"
          variant="contained"
          size="small"
          disabled={!name}
        >
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
